export const LINEAR_PROGRESS_WIDGET_MODEL = {
  createModel: (percentage: number, color: string): Highcharts.Options => {
    return {
      chart: {
        type: 'bar',
        height: 40,
        backgroundColor: 'transparent',
        borderRadius: 10,
        borderWidth: 0,
      },
      title: {
        text: '',
      },
      xAxis: {
        visible: false,
      },
      yAxis: {
        visible: false,
        min: 0,
        max: 100,
      },
      plotOptions: {
        series: {
          animation: false,
          stacking: 'normal',
          dataLabels: {
            enabled: false,
          },
        },
      },
      series: [
        {
          type: 'bar',
          name: 'background',
          data: [100 - Math.min(percentage, 100)],
          color: '#808080',
          borderWidth: 0,
          borderRadius: 10,
          pointWidth: 20,
        },
        {
          type: 'bar',
          name: 'Progress',
          data: [Math.min(percentage, 100)],
          color: color,
          borderWidth: 0,
          borderRadius: 10,
          pointWidth: 20,
        },
      ],
      tooltip: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      exporting: {
        enabled: false,
      },
      navigation: {
        menuItemStyle: {
          display: 'none',
        },
        buttonOptions: {
          enabled: false,
        },
      },
    };
  },
};
